"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_COLUMN_FILTER = exports.SET_SEARCH_STRING = exports.SET_ORDER_BY = exports.CLEAR = exports.TOGGLE_MODAL = void 0;
exports.TOGGLE_MODAL = '@sok/sokosite/configModal/TOGGLE_MODAL';
exports.CLEAR = '@sok/sokosite/configModal/CLEAR';
exports.SET_ORDER_BY = '@sok/sokosite/configModal/SET_ORDER_BY';
exports.SET_SEARCH_STRING = '@sok/sokosite/list/SET_SEARCH_STRING';
exports.SET_COLUMN_FILTER = '@sok/sokosite/configModal/SET_COLUMN_FILTER';
//# sourceMappingURL=configModal.js.map